import React from 'react';

const ProgressBar = () => {
    return (
        <div className=" hidden  sm:flex flex-row progressBar  rounded-lg mt-2 w-full ">
            <div className="flex flex-row  h-1 bg-white rounded-lg w-full items-center ">
                <div className={`h-1.5 bg-gold-accent rounded-lg w-32 `}></div>
            </div>
        </div>
    );
};

export default ProgressBar;